import { ICON_COLOR_STYLE_NAMES } from 'Utils/customStyling';

export function getStatusStyle(status) {
  switch (status) {
    case 'OPEN':
      return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_ORANGE;
    case 'RENEGE':
      return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_RED;
    case 'ONBOARDED':
      return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_GREEN;
    case 'ACTIVE':
      return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_GREEN;
    case 'INACTIVE':
      return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_GREY;
  }
}
